export default __webpack_public_path__ + "static/logo-ea7d9bcdf679c4ed1ea70d856ef0412e.gif";